import React from 'react'
import styled from 'styled-components'

const Skeleton = styled.div`
  background: #f3f3f3;
  height: 420px;
  overflow: hidden;
`
const EventGridCardSkeleton = ({}) => {
  return <Skeleton />
}

export default EventGridCardSkeleton
